import { Request } from '@group-devs/yfp7-global-modules'
import {useEffect} from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { DashboardTopNav, LEProgress, WellnessTopNav } from '@components/Block'
import { HeroWrapper, Footer } from '@group-devs/yfp7-global-modules/components/Block'
import styles from '@group-devs/yfp7-global-modules/components/hero.module.css'
import Image from 'next/image'
import ReactGA from 'react-ga';

const request = new Request(process.env.apiDomain)

function Layout(props) {
  const router = useRouter()
  
  const auth = props.global.auth
  const site = props.global.site
  const { data: hub } = request.website.swrSite(site.accountId, "HUB")
  const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
  const { data: tracker } = request.insights.swrTracking(site.id)

  useEffect(()=>{
    if (tracker)
    {
      if (tracker.ga_id)
      {
        ReactGA.initialize(tracker.ga_id);
        ReactGA.pageview(window.location.pathname + window.location.search);
      }
      if (tracker.matomo_id && tracker.matomoServer)
      {
        var _paq = window._paq = window._paq || [];
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
          var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
          _paq.push(['setTrackerUrl', u+'/matomo.php']);
          _paq.push(['setSiteId', tracker.matomo_id]);
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
        })();
      }
    }
  }, [tracker])

  const title = site.name + " - Learn and Earn"
  const description = "Discover how to have long-lasting vitality and well-being with Shaklee products in my wellness center."

  return (
    <div className="page-layout wellnessCenter position-relative">
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={"Your Wellness Project, Learn and Earn, " + site.name} />
        <meta name="author" content={site.name} />
        <meta property="og:url" content={ "//" + site.url + router.asPath } key="url"/>
        <meta property="og:site_name" content={ site.name + " - Learn and Earn"} />
        <meta property="og:type" content="Website"/>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/themes/014-cobalt/assets/images/img/img-share02.jpg"/>
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet"/>
      </Head>
      <WellnessTopNav site={site} auth={auth}/>
        <div>
          <HeroWrapper 
          image={<span className="d-block mt-3 mr-5"><Image src="/images/learnandearn/img-learn-and-earn-program.svg" width={125} height={113} alt="learn and earn" /></span>} 
          title="Learn and Earn Program" 
          description={<>Increase your wellness IQ and earn rewards <br/> while enjoying science-based wellness content.</>}
          classname={styles.leoverview} />
        </div>
        <div className="progressle position-absolute text-white">
          <LEProgress/>
        </div>
        {props.children}
      { nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} origin="wellness"/> : null }
      <style jsx global>{`
        body{
          font-family: 'Montserrat', sans-serif;
          color:#232323;
        }
        .dropdown-item{
          color:#232323;
          padding: .25rem 1rem;
        }
        .footer__menu {
            background-color: #f7f7f7!important;
            color:#000!important;
        }
        .footer__links{
          color:#000!important;
        }
        .footer__socialLinks{
          border-color: #43a649!important;
          background-color: #43a649;
        }
        .footer__menuLinks {
            border-color:#43a649!important
        }
        .progressle{
          right: 11rem;
          top: 11.8rem;
          width: 350px;
        }
        .progressle .progress{
          height: 1rem;
        }
        .dashboard_title__2YNki{
          margin-bottom: 0!important;
          margin-left: 1.5rem;
        }
        .dashboard_desc__1c5_X{
          margin-left: 1.5rem;
        }
        
        .myStrip__media{
          background-color: #828282;
        }
      `}</style>
    </div>
  )
}
  
export default Layout